module.exports = __webpack_public_path__ + "img/product-surety-bond.45a46c5b.jpeg";